//Button Export contacts to xls

// Path: src\Components\ExportButton.js
// Compare this snippet from src\Components\SmsBlock.js:
import React, {useState, useEffect}  from 'react'
import { Button, Table } from '@nextui-org/react';

const ExportButton = ({contacts}) => {
    var XLSX = require('xlsx');
    const [contactsList, setContactsList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

   useEffect(() => {
        if(contacts){
            setContactsList(contacts);
        }
    }, [contacts])

    //Export contacts to xls without id 
    const exportToXls = (contacts) => {
        setLoading(true);
        let contactsToExport = [];
        contacts.forEach(contact => {
            let contactToExport = {
                'Nom': contact.name,
                'Numero': contact.phone,
            }
            contactsToExport.push(contactToExport);
        })
        const ws = XLSX.utils.json_to_sheet(contactsToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Contacts");
        XLSX.writeFile(wb, "contacts.xlsx");
        setLoading(false);
    }


    return (
        <Button
        css={{ width: '100%' }}
            color="primary"
            onClick={() => exportToXls(contactsList)}
            loading={loading}
            disabled={loading}
        >
            Exporter
        </Button>
    )
}

export default ExportButton